import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

import CartItemDvdIcon from './CartItemDvdIcon';
import CartAdditionalProduct from './CartAdditionalProduct';
import { DvdMsg } from '../../messages';

function CartAdditionalProductDvd(props) {
  const { additionalProduct, ...other } = props;
  return (
    <CartAdditionalProduct
      additionalProduct={additionalProduct}
      hasHelpIcon={true}
      icon={
        <div className="cart-item-icon-container">
          <CartItemDvdIcon />
        </div>
      }
      title={<DvdMsg />}
      {...other}
    />
  );
}

CartAdditionalProductDvd.propTypes = {
  additionalProduct: PropTypes.object,
};

export default createFragmentContainer(CartAdditionalProductDvd, {
  additionalProduct: graphql`
    fragment CartAdditionalProductDvd_additionalProduct on Product {
      ...CartAdditionalProduct_additionalProduct
    }
  `,
});
